import { useId, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../../common/components/button/button';
import { ROUTES } from '../../../core/constants/routes';
import { describeApiError } from '../../../core/network/error';
import { useAuth } from '../../../global/contexts/auth/auth';

import '../styles/login.css';

const SAFE_REDIRECTS = /^\/admin\/[a-z0-9/-]*$/;

// Only internal admin paths are accepted as post-login targets (open-redirect guard).
function safeTarget(candidate) {
    return typeof candidate === 'string' && SAFE_REDIRECTS.test(candidate) ? candidate : ROUTES.HOME;
}

export default function LoginForm() {
    const emailId = useId();
    const passwordId = useId();
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!email.trim() || !password) {
            setError('Escribe tu correo y tu contraseña.');
            return;
        }
        setIsSubmitting(true);
        setError(null);
        try {
            await login({ email, password });
            navigate(safeTarget(location.state?.from), { replace: true });
        } catch (err) {
            setError(err?.status === 400 || err?.status === 401 ? 'Correo o contraseña incorrectos.' : describeApiError(err));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form className="login-form" onSubmit={handleSubmit} noValidate>
            <label htmlFor={emailId} className="login-form__label">Correo</label>
            <input
                id={emailId}
                className="login-form__input"
                type="email"
                autoComplete="username"
                inputMode="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
            />
            <label htmlFor={passwordId} className="login-form__label">Contraseña</label>
            <input
                id={passwordId}
                className="login-form__input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
            />
            {error && <p className="login-form__error" role="alert">{error}</p>}
            <Button type="submit" variant="primary" isBlock isBusy={isSubmitting}>Entrar</Button>
            <p className="login-form__note">
                La sesión vive en una cookie httpOnly de Core. Esta app nunca guarda tokens, y la biometría del dispositivo no sustituye este acceso.
            </p>
        </form>
    );
}
